import React, { Component } from "react";
import { CSVLink } from "react-csv";
import SpinnerSmall from "./SpinnerSmall";

export default class ReportHeader extends Component {
  render() {
    return (
      <div className="report-header">
        <div>
          <h4>{this.props.title}</h4>
        </div>
        <div className={`d-flex ${this.props.hideAction && "hidden"}`}>
          {this.props.hideAction ? null : this.props.csvLoading ? (
            <div className="d-flex btn btn-primary m-0 disabled">
              <div className="color-white mr-05">
                <span>Loading CSV</span>
              </div>
              <SpinnerSmall />
            </div>
          ) : this.props.fromFile ? (
            <div className={this.props.actionClass}>
              <div className="color-white mr-05" onClick={this.props.loadCsv}>
                <span>{this.props.actionTitle}</span>
              </div>
            </div>
          ) : (
            <CSVLink
              className={this.props.actionClass}
              filename={this.props.filename}
              headers={this.props.headers}
              data={this.props.csvData}
            >
              {this.props.actionTitle}
            </CSVLink>
          )}
          {this.props.showPdfButton &&
            (this.props.hideAction ? null : this.props.pdfLoading ? (
              <div className="d-flex btn btn-primary m-0 ml-1 disabled">
                <div className="color-white mr-05">
                  <span>Loading PDF</span>
                </div>
                <SpinnerSmall />
              </div>
            ) : (
              <div className={this.props.actionClass2}>
                <div className="color-white mr-05" onClick={this.props.printPdf}>
                  <span>{this.props.actionTitle2}</span>
                </div>
              </div>
            ))}
        </div>
      </div>
    );
  }
}
